import { useCompensationSelectionStore } from '@stores';
import { CompensationStoreEnum } from 'src/stores/compensationSelectionStore';
import { useStore } from 'zustand';

export const allSteps = {
  1: 'cotizador',
  2: 'personal',
  3: 'contacto',
  4: 'datos-familiares',
  5: 'seleccion-indemnizacion',
  6: 'designar-beneficiarios',
  7: 'checkout',
  8: 'pago-toku',
  9: 'exito',
} as const;
type ValuesOf<T> = T[keyof T];
type AllStepsType = ValuesOf<typeof allSteps>;

export const staticMaxSteps = Object.keys(allSteps).length + 1;

interface UseStepsProps {
  currentStepName: AllStepsType;
}

const useSteps = ({ currentStepName }: UseStepsProps) => {
  const compensationSelection = useStore(
    useCompensationSelectionStore,
    (state) => state.compensationSelection
  );

  const stepsArray = Object.entries(allSteps)
    .map(([field, value]) => `${field} ${value}`)
    .sort();
  const maxSteps = Object.keys(allSteps).length + 1;

  const stepNumbers = Object.fromEntries(
    Object.entries(allSteps).map(([key, value]) => [value, parseInt(key)])
  );

  const filterSteps = stepsArray.filter((step) => {
    let condition = true;
    if (compensationSelection === CompensationStoreEnum.LEGAL_HEIRS) {
      condition = !step.includes('designar-beneficiarios');
    }
    return condition;
  });

  const currentStep = filterSteps.findIndex((step) => step.includes(currentStepName)) + 1;

  return {
    allSteps,
    maxSteps,
    stepNumbers,
    currentStep,
    count: filterSteps.length + 1 - currentStep,
  };
};

export default useSteps;
